import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AppRole } from './api.types';

export interface AdminUserRow {
	id: string;
	email: string | null;
	name: string | null;
	image: string | null;
	role: AppRole;
	isApproved: boolean;
	approvalStatus: string;
	accessRequestedAt: string | null;
	accessRequestNote: string | null;
	createdAt: string;
}

export interface AdminUsersListResponse {
	users: AdminUserRow[];
}

@Injectable({ providedIn: 'root' })
export class AdminUsersService {
	constructor(private readonly http: HttpClient) {}

	list(): Observable<AdminUsersListResponse> {
		return this.http.get<AdminUsersListResponse>(`${environment.api.baseUrl}/v1/admin/users`);
	}

	updateRole(userId: string, role: AppRole): Observable<{ ok: boolean }> {
		return this.http.patch<{ ok: boolean }>(
			`${environment.api.baseUrl}/v1/admin/users/${userId}/role`,
			{ role }
		);
	}
}
